import {
  HandlePrevYearClick,
  HandleNextYearClick,
  YearPicker,
} from '@/domain/mitarbeiter/features/feiertagskonto/components/dateNavigation/shared';
import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import { Button } from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export function DateNavigatorDesktop() {
  const { t } = useTranslation();

  //TODO: Abrechnungszeitraum 1.1.  - 31.12. ? Kann sich verschieben?
  const { year, setYear } = useYearPickerContext();
  const handleTodayClick = () => {
    setYear(year.year(dayjs().year()));
  };

  return (
    <div className="flex flex-row items-center gap-1 text-brand-blue-100">
      <Button onClick={handleTodayClick} variant="outline-on-grey">
        {t('general.date.today')}
      </Button>
      <HandlePrevYearClick />
      <HandleNextYearClick />
      <YearPicker className="text-xl" />
    </div>
  );
}
